import React from 'react';
import { Mail, Phone, Globe, ShieldCheck } from 'lucide-react';

const CommodityContact = ({ company }) => (
  <div className="min-h-screen bg-slate-50 text-slate-900 animate-in fade-in duration-700">
    <div className="py-16 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto">
      
      {/* Main Contact Card */}
      <div className="bg-white rounded-[2rem] lg:rounded-[3rem] overflow-hidden shadow-2xl flex flex-col md:flex-row border border-blue-100">
        
        {/* Left Side: Corporate Info (Blue/Indigo Gradient) */}
        <div className="p-8 sm:p-12 lg:p-16 bg-gradient-to-br from-blue-700 via-blue-800 to-indigo-900 text-white md:w-5/12 relative overflow-hidden">
          {/* Subtle Background Pattern */}
          <div className="absolute inset-0 opacity-10 pointer-events-none bg-[radial-gradient(circle_at_20%_30%,rgba(255,255,255,0.2),transparent)]"></div>
          
          <div className="relative z-10">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black mb-6 leading-tight tracking-tighter">
              Global <span className="text-sky-300">Trade</span> Desk
            </h2>
            
            <p className="text-blue-100/90 mb-10 text-lg leading-relaxed font-medium italic">
              "Connecting Sri Lankan excellence to the global stage."
            </p>

            <div className="space-y-6">
              <div className="flex items-center gap-4 p-5 bg-white/10 rounded-2xl border border-white/20 hover:bg-white/20 transition-all group">
                <div className="w-10 h-10 rounded-xl bg-sky-400/20 flex items-center justify-center">
                  <Mail className="text-sky-300" size={20} />
                </div>
                <div>
                  <p className="text-xs uppercase tracking-widest text-sky-200 font-bold">Email us</p>
                  <a href='mailto:spicegrainscommodities@ddlankagroup.com' className="font-semibold text-sm sm:text-base">spicegraincommodities@ddlankagroup.com</a>
                </div>
              </div>
              
              <div className="flex items-center gap-4 p-5 bg-white/10 rounded-2xl border border-white/20 hover:bg-white/20 transition-all group">
                <div className="w-10 h-10 rounded-xl bg-sky-400/20 flex items-center justify-center">
                  <Phone className="text-sky-300" size={20} />
                </div>
                <div>
                  <p className="text-xs uppercase tracking-widest text-sky-200 font-bold">Call Center</p>
                  <a href='tel:+94778197763' className="font-semibold text-sm sm:text-base">+94 77 8 197 763</a>
                </div>
              </div>

              <div className="pt-8 mt-8 border-t border-white/10 flex items-center gap-3 text-sm text-blue-200">
                <ShieldCheck size={20} className="text-sky-400" />
                <span>Certified Export Partner & Licensed Shipper</span>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side: Professional Form */}
        <div className="p-8 sm:p-12 lg:p-16 bg-white md:w-7/12">
          <h3 className="text-2xl font-bold text-slate-800 mb-8 flex items-center gap-2">
            Business Inquiry <span className="w-2 h-2 rounded-full bg-sky-500"></span>
          </h3>
          
          <form
            className="space-y-5"
            onSubmit={(e) => {
              e.preventDefault();
              alert('Trade inquiry received! Our representative will contact you shortly.');
            }}
          >
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              <input
                type="text"
                placeholder="Name *"
                required
                className="w-full p-4 rounded-xl border border-slate-200 bg-slate-50 focus:border-blue-500 focus:bg-white focus:outline-none transition-all"
              />
              <input
                type="email"
                placeholder="Business Email *"
                required
                className="w-full p-4 rounded-xl border border-slate-200 bg-slate-50 focus:border-blue-500 focus:bg-white focus:outline-none transition-all"
              />
            </div>

            <select
              className="w-full p-4 rounded-xl border border-slate-200 bg-slate-50 focus:border-blue-500 focus:bg-white focus:outline-none transition-all text-slate-600 font-medium"
              required
            >
              <option value="">Select Category *</option>
              <option value="export">Export Inquiry</option>
              <option value="wholesale">Wholesale Partnership</option>
              <option value="logistics">Logistics & Supply Chain</option>
            </select>

            <textarea
              placeholder="Requirement details (Products, Volume, Destination)..."
              rows="4"
              required
              className="w-full p-4 rounded-xl border border-slate-200 bg-slate-50 focus:border-blue-500 focus:bg-white focus:outline-none transition-all resize-none"
            ></textarea>

            <button
              type="submit"
              className="w-full py-5 bg-blue-600 text-white rounded-xl font-bold text-lg hover:bg-blue-700 hover:shadow-lg hover:shadow-blue-200 transition-all flex items-center justify-center gap-3 group"
            >
              <span>Submit Inquiry</span>
              <Globe size={18} className="group-hover:rotate-12 transition-transform" />
            </button>
          </form>
        </div>
      </div>

      {/* Trust Badges */}
      <div className="mt-12 flex flex-wrap justify-center gap-8 opacity-60 grayscale hover:grayscale-0 transition-all duration-500">
        <div className="flex items-center gap-2 font-bold text-slate-500">
          <span className="text-2xl italic">Global</span> Standards
        </div>
        <div className="flex items-center gap-2 font-bold text-slate-500">
          <span className="text-2xl italic">ISO</span> 9001
        </div>
        <div className="flex items-center gap-2 font-bold text-slate-500">
          <span className="text-2xl italic">Sea</span> Freight
        </div>
      </div>
    </div>
  </div>
);

export default CommodityContact;